'use client';

import { useEffect, useRef } from 'react';
import AppImage from '@/components/ui/AppImage';


const stats = [
{ value: '2h', label: 'économisées par jour avec les bons outils', color: 'text-moss-light' },
{ value: '40%', label: 'de revenus en plus grâce à la tarification dynamique', color: 'text-gold' },
{ value: '30%', label: 'de temps ménage réduit par synchronisation automatique', color: 'text-moss-light' },
{ value: '5–150', label: 'logements : la cible sous-équipée du marché', color: 'text-cream/80' }];


export default function WhySection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.reveal-el').forEach((el, i) => {
              setTimeout(() => el.classList.add('revealed'), i * 120);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    if (sectionRef?.current) observer?.observe(sectionRef?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section id="programme" className="py-28 px-6 border-t border-white/[0.05]" ref={sectionRef}>
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: image + floating card */}
          <div className="relative reveal-el">
            <div className="aspect-[4/5] rounded-[2.5rem] overflow-hidden shadow-2xl shadow-black/50">
              <AppImage
                src="https://img.rocket.new/generatedImages/rocket_gen_img_1f2e3823e-1770655422595.png"
                alt="Gestionnaire de conciergerie travaillant sur ordinateur dans un bureau moderne"
                className="w-full h-full object-cover" />
              
            </div>
            {/* Floating stat card */}
            <div className="absolute -bottom-8 -right-6 glass-card p-6 rounded-2xl max-w-[240px] shadow-xl hidden md:block">
              <p className="font-fraunces italic text-3xl text-moss-light mb-1">–50%</p>
              <p className="text-cream/60 text-sm leading-snug">
                du temps sur la gestion des réservations et plannings, selon nos partenaires bêta
              </p>
            </div>
          </div>

          {/* Right: text */}
          <div className="space-y-8">
            <div className="reveal-el">
              <p className="text-moss-light font-bold uppercase tracking-[0.25em] text-xs mb-4">Pourquoi ce programme existe</p>
              <h2 className="font-fraunces text-5xl md:text-6xl font-light italic leading-tight text-cream">
                La gestion multi-biens<br />
                <span className="text-moss-light">mérite mieux.</span>
              </h2>
            </div>

            <p className="text-cream/60 text-lg leading-relaxed reveal-el">
              Gérer 5, 20 ou 50 logements en location saisonnière sans outil structuré, c'est accepter de perdre du temps, des revenus et de l'énergie chaque semaine. Les surréservations, les plannings désynchronisés, les messages non automatisés : ces problèmes ont une solution.
            </p>

            <p className="text-cream/60 leading-relaxed reveal-el">
              GiteZen est conçu pour les petites et moyennes structures de conciergerie. Ce programme partenaire existe pour <strong className="text-cream">tester l'outil en conditions réelles</strong>, affiner les fonctionnalités avec des professionnels de terrain, et construire ensemble des études de cas solides.
            </p>

            {/* Stats grid */}
            <div className="grid grid-cols-2 gap-4 reveal-el">
              {stats?.map((stat, i) =>
              <div key={i} className="glass-card rounded-xl p-4 spotlight-card">
                  <p className={`font-fraunces text-3xl font-light italic mb-1 ${stat?.color}`}>{stat?.value}</p>
                  <p className="text-cream/50 text-xs leading-snug">{stat?.label}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>);

}